"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _jsCookie = _interopRequireDefault(require("js-cookie"));

var _queryString = _interopRequireDefault(require("query-string"));

/**
 * 一个小于 `700 bytes` 的轻量的处理 `cookie` 的 `JavaScript` 库
 * @module cookie
 * @see [js-cookie - GitHub](https://github.com/js-cookie/js-cookie)
 */

/**
 * 设置 cookie 项
 * @method set
 * @param {String} name
 * @param {String} value
 * @param {Object} [options]
 * @param {Number} [options.expires] 有效期，单位天
 * @param {String} [options.path] 有效路径
 * @param {String} [options.domain] 有效域名
 * @example cookie.set('name', 'value', { expires: 7 })
 */

/**
 * 获取 cookie 项
 * @method get
 * @param {String} name
 * @param {Object} [options]
 * @param {Number} [options.expires] 有效期，单位天
 * @param {String} [options.path] 有效路径
 * @param {String} [options.domain] 有效域名
 * @return {String}
 * @example cookie.get('name')
 */

/**
 * 移除 cookie 项
 * @method remove
 * @param {String} name
 * @param {Object} [options]
 * @param {Number} [options.expires] 有效期，单位天
 * @param {String} [options.path] 有效路径
 * @param {String} [options.domain] 有效域名
 * @example cookie.remove('name')
 */

/**
 * 依次获取 cookie.ZZU -> cookie.PPU，以对象格式返回
 * @method getPPU
 * @return {Object}
 * @example cookie.getPPU()
 */
_jsCookie.default.getPPU = function getPPU() {
  var ppu = _jsCookie.default.get('ZZU') || _jsCookie.default.get('PPU') || '';
  return _queryString.default.parse(ppu);
};
/**
 * 获取 uid，依次取 cookie.uid -> cookie.ZZU.UID -> cookie.PPU.UID
 * @method getUid
 * @return {String}
 * @example cookie.getUid()
 */


_jsCookie.default.getUid = function getUid() {
  return _jsCookie.default.get('uid') || _jsCookie.default.getPPU().UID || '';
};

var _default = _jsCookie.default;
exports.default = _default;